import { useRouteTracking } from '../../hooks/useRouteTracking';

function TrackRouting() {
  useRouteTracking();

  return null;
}

export { TrackRouting };
